export const environment = {
    production: true,
    apiAuthUrl: 'https://lockers.biters.it/api-server/api/auth/',
    apiAuthPublicUrl: 'https://lockers.biters.it/api-server/api/auth/public/',
    apiFsUrl: 'https://lockers.biters.it/api-server/api/fs/',
    apiFsPublicUrl: 'https://lockers.biters.it/api-server/api/fs/public/',
    apiCoreUrl: 'https://lockers.biters.it/api-server/api/core/',
    apiCorePublicUrl: 'https://lockers.biters.it/api-server/api/core/public/',
    apiUrl: 'https://lockers.biters.it/api-server/api/'
};
